<form [formGroup]="formGroup">
  <div class="mydocma-form-field-wrapper" style="padding-top: 2px">
    <mydocma-custom-mat-icon class="scope-cell-style" *ngIf="scope === scopes.Global"  [iconName]="'_globe'"></mydocma-custom-mat-icon>
    <mydocma-custom-mat-icon class="scope-cell-style" *ngIf="scope === scopes.Project"  [iconName]="'_company'"></mydocma-custom-mat-icon>
    <mydocma-custom-mat-icon class="scope-cell-style" *ngIf="scope === scopes.User"  [iconName]="'_user'"></mydocma-custom-mat-icon>
  </div>
</form>
